<template>
  <div>
    <JsonLd>
      {{ structuredData }}
    </JsonLd>

    <div class="breadcrumbs" v-if="breadcrumbs.length">
      <b class="mr-1">{{ t('messages.you-are-here') }}:</b>
      <ol class="breadcrumbs__list">
        <li v-for="crumb in breadcrumbs"
            :key="crumb.route"
            class="breadcrumbs__item">
          <RouterLink class="breadcrumbs__link"
                      :to="crumb.route"
                      v-if="crumb.route">
            <span>{{ crumb.name }}</span>
          </RouterLink>
          <span v-else class="breadcrumbs__link">
            {{ crumb.name }}
          </span>
        </li>
      </ol>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import JsonLd from '@/components/partials/JsonLd.vue'
import { useBreadcrumbStore } from '@/stores/useBreadcrumbStore'
import { storeToRefs } from 'pinia'

const {t} = useI18n()

const {breadcrumbs} = storeToRefs(useBreadcrumbStore())

const structuredData = computed(() => {
  if (!breadcrumbs.value.length) {
    return null
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.value.map((crumb, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.name,
        item: crumb.route.href,
      }
    }),
  }
})
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables/variables.scss";

.breadcrumbs {
  font-size: $font-size-sm;

  &__list {
    display:    inline-block;
    list-style: none;
    margin:     0;
    padding:    0;
  }

  &__item {
    display: inline-block;

    &:after {
      content: "›";
      margin:  0 0.5em;
      color:   var(--color-neutral-secondary);
    }

    &:last-child {
      &:after {
        content: "";
      }
    }
  }
}
</style>
